import VinaySrivastavaImage from '../assets/VinaySrivsatava.png';
import MhIkramImage from '../assets/MhIkram.png';
import SnehaTripathiImage from '../assets/SnehaTripathi.png';
import RahulJainImage from '../assets/RahulJain.png';

export const reviews = [
    {
      id: 1,
      name: "Mh. Ikram",
      designation: "Principal",
      company: "SPN School, Noida",
      review:
        "The analytics and reporting tools are incredibly detailed. Helps us track student performance and attendance effortlessly. Worth every penny!",
      imageUrl: MhIkramImage,
    },
    {
      id: 2,
      name: "Sneha Tripathi",
      designation: "Teacher ",
      company: "",
      review:
        "Overall, a great platform. The communication tools save us a lot of time. Would love to see even more integrations in the future!",
      imageUrl: SnehaTripathiImage,
    },
    {
      id: 3,
      name: "Rahul Singh",
      designation: "School Admin",
      company: "St. Joseph, Pratapgarh",
      review:
        "Absolutely love this software! It's made school administration so smooth and hassle-free. The AI tutor is fantastic for students too. Highly recommend!",
      imageUrl: RahulJainImage,
    },
    {
      id: 4,
      name: "Vinay Srivastava",
      designation: "Parent",
      company: "",
      review:
        "The app is super helpful for parents like me. The modern, clean interface makes it easy to navigate, and real-time updates keep me in the loop about my child's progress. Really impressed with how smooth everything feels!",
      imageUrl: VinaySrivastavaImage,
    },
  ];